import { takeEvery, takeLatest } from 'redux-saga/effects';
import { VIOLATIONS_MODULE } from '../../../configs/moduleNames';
import {
  LOAD_VIOLATION_LIST,
  CREATE_VIOLATION,
  DELETE_VIOLATION,
  EDIT_VIOLATION_BY_ID,
  GENERATE_VIOLATION_PROTOCOL_PDF,
  LOAD_VIOLATION_BY_ID,
} from '../actions';

import loadViolationList from './loadViolationList';
import createViolation from './createViolation';
import loadViolationById from './loadViolationById';
import editViolationById from './editViolationById';
import deleteViolation from './deleteViolation';
import generateViolationProtocolPdf from './generateViolationProtocolPdf';

export default function* watchDashboard() {
  yield takeLatest(VIOLATIONS_MODULE + LOAD_VIOLATION_LIST, loadViolationList);
  yield takeLatest(VIOLATIONS_MODULE + CREATE_VIOLATION, createViolation);
  yield takeEvery(VIOLATIONS_MODULE + LOAD_VIOLATION_BY_ID, loadViolationById);
  yield takeEvery(VIOLATIONS_MODULE + EDIT_VIOLATION_BY_ID, editViolationById);
  yield takeEvery(VIOLATIONS_MODULE + DELETE_VIOLATION, deleteViolation);
  yield takeLatest(VIOLATIONS_MODULE + GENERATE_VIOLATION_PROTOCOL_PDF, generateViolationProtocolPdf);
}
